import { FC } from "react";
import Tippy, { TippyProps } from "@tippyjs/react";

const PersistentTippy: FC<TippyProps> = (props) => {
  return <Tippy showOnCreate hideOnClick="toggle" trigger="click" {...props} />;
};

export default PersistentTippy;
